
const enum_json = require('@/assets/json/enum.json');

const state = {
  // 创意规格id
  adcreative_template_id: '',
  // 创意规格资源限制
  restriction: {
    width: 0,
    height: 0,
  },
  // 创意资源类别
  material_type: 'image',
  // 广点通出价方式
  bid_mode: 'BID_MODE_OCPM',
  // 广告版位
  site_set: [],
  // 广点通推广目标
  promoted_object_type: 'PROMOTED_OBJECT_TYPE_APP_ANDROID',
  test: false,
  // 分割线
  enum_json,
  loading: false,
  plans: [],
  schedule_time: [],

  // 第一步 推广计划
  plan: {
    // 推广目的
    landing_type: '',
    // 推广平台 当download_type为DOWNLOAD_URL时必填
    app_type: '',
    // 安卓版本
    android_osv: '',
    // IOS版本
    ios_osv: '',
    // 当app_type=android时
    hide_if_exists: null,
    // 投放范围
    delivery_range: '',
    // 投放形式
    union_video_type: '',
  },
  // 第二部 投放目标
  target: {
    // 付费方式 (投放目标)
    pricing: '',
    // landing_type=APP时 显示下载方式
    download_type: '',
    // 当download_type为DOWNLOAD_URL时 显示下载链接
    download_url: '',
    // 当download_type为DOWNLOAD_URL时 显示应用包名
    package: '',
  },
  // 第三部 出价与预算
  bid_on_budget: {
    // 出价方式
    smart_bid_type: '',
    // 投放方式
    flow_control_mode: '',
    // 广告预算类型
    budget_mode: '',
    // 广告预算 出价方式为CPC、CPM、CPV时，不少于100元；出价方式为OCPM、OCPC时，不少于300元
    budget: null,
    // 投放时间类型
    schedule_type: '',
    // 广告投放起始时间
    start_time: '',
    // 广告投放结束时间
    end_time: '',
    // 出价 当pricing为”CPC”、”CPM”、”CPV
    bid: null,
    // 深度出价方式
    deep_bid_type: '',
    // 深度转化出价 deep_bid_type为”DEEP_BID_MIN”时必填
    deep_cpabid: null,
    // 过滤已转化用户
    hide_if_converted: '',
  },

  // 批量参数
  batch: {
    // 广告主ID
    advertiser_id: null,
    // 广告组ID
    campaign_id: null,
    // 落地页
    external_url: '',
    // 转化目标
    convert_id: null,
    // 广告名称
    name: '',
    // 定向包
    audience_package_id: null,
  },
  industry_list: [],
  medias_list: [],
  // 第四部 创意
  creative: {
    // 创意标签 (最多20个标签,且每个标签长度不超过10个字符)
    ad_keywords: '',
    // 创意分类
    third_industry_id: null,

    // 当推广目的为非DPA时需传字段,创建程序化创意（与自定义选其一）
    // 创意类型
    creative_material_mode: '',
    // 程序化创意包id
    procedural_package_id: null,
    // 素材参数material 详情看下方素材类别json
    material: {
      CREATIVE_IMAGE_MODE_SMALL: [],
      CREATIVE_IMAGE_MODE_LARGE: [],
      CREATIVE_IMAGE_MODE_GROUP: [],
      CREATIVE_IMAGE_MODE_VIDEO: [],
      CREATIVE_IMAGE_MODE_GIF: [],
      CREATIVE_IMAGE_MODE_LARGE_VERTICAL: [],
      CREATIVE_IMAGE_MODE_VIDEO_VERTICAL: [],
      TOUTIAO_SEARCH_AD_IMAGE: [],
      SEARCH_AD_SMALL_IMAGE: [],
    },

    // 当推广目的为Link（landing_type=LINK）时需传字段
    // 附加创意类型
    advanced_creative_type: '',
    // 副标题
    advanced_creative_title: '',
    // 电话号码
    phone_number: '',
    // 按钮文本
    button_text: '',
    // 表单提交链接 (当附加创意类型为”ATTACHED_CREATIVE_FORM”时 必填, 当附加创意类型为ATTACHED_CREATIVE_FORM时, 必须为今日头条建站地址)
    form_url: '',

    // 当推广目的为APP（landing_type=APP）时需传字段
    // 文章来源, 当（计划）download_type为”EXTERNAL_URL时”时必填
    source: '',
    // 应用名，当（计划）download_type为”DOWNLOAD_URL”时, 必填)
    app_name: '',
    // 行动号召
    action_text: '',
    // APP 副标题 仅推广目标为APP，填写android下载链接时可设置
    sub_title: '',
    // Android应用下载详情页 当（计划）app_type为”APP_ANDROID”时, 必填)
    web_url: '',
  },
  // 素材库
  material_center: {
    show: false,
    response: {
      list: [],
      page_info: {
        total_number: 0,
        page_size: 9,
      },
    },
    params: {
      material_type: 'image',
      advertiser_id: null,
      image_mode: null,
      limit: 9, // 一页显示条数
      page: 1,
    },
    resource: {
      image_check: 'CREATIVE_IMAGE_MODE_SMALL',
      image_mode_list: [
        { label: 'CREATIVE_IMAGE_MODE_SMALL', index: 0, images: [] },
        { label: 'CREATIVE_IMAGE_MODE_LARGE', index: 0, images: [] },
        { label: 'CREATIVE_IMAGE_MODE_GROUP', index: 0, images: [] },
        { label: 'CREATIVE_IMAGE_MODE_VIDEO', index: 0, images: [] },
        { label: 'CREATIVE_IMAGE_MODE_GIF', index: 0, images: [] },
        {
          label: 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL',
          index: 0,
          images: [],
        },
        {
          label: 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL',
          index: 0,
          images: [],
        },
        { label: 'TOUTIAO_SEARCH_AD_IMAGE', index: 0, images: [] },
        { label: 'SEARCH_AD_SMALL_IMAGE', index: 0, images: [] },
      ],
      editableTabsValue: '2',
      image_url: [],
      pic_check: '',
      now_id: null,
    },
  },
};
export default {
  state,
};
